
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderInstallmentReportGrid extends Serenity.EntityGrid<OrderInstallmentReportRow, any> {
        protected getColumnsKey() { return OrderInstallmentReportColumns.columnsKey; }
        protected getDialogType() { return OrderInstallmentReportDialog; }
        protected getIdProperty() { return OrderInstallmentReportRow.idProperty; }
        protected getInsertPermission() { return OrderInstallmentReportRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderInstallmentReportRow.localTextPrefix; }
        protected getService() { return OrderInstallmentReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}